<i-title [text]="'valves.title' | translate" [buttons]="titleButtons"></i-title>

<div class="valves-list">
  <i-tabs [items]="steps" (slug_name)="changeStep($event)"></i-tabs>

  <i-table
    *ngIf="!loading"
    [items]="items"
    [columns]="columns"
    [showAdvancedSearchBtn]="false"
    [search]="false"
    [multiselect]="false"
    [menu]="menu"
    [rows]="valveService.currentValvePagination.pageSize || 50"
    [totalRecords]="valveService.currentValvePagination.totalCount || 50"
    [first]="valveService.currentValvePagination.pageNumber || 1"
    [loading]="tableLoading"
    [lazy]="true"
    [height]="'80vh'"
    (onLazyLoad)="onTableUpdate($event)"
  ></i-table>

  <div class="valves-list__loader" *ngIf="loading">
    <i-loader></i-loader>
  </div>
</div>

<app-confirmation-dialog></app-confirmation-dialog>
